import { apiTransitionDocumentsForm, submitDocumentsDataSuccess } from '../../../actions/motorPrivateRW/Documents';
import { getAccessToken } from '../../../selectors/motorPrivateRW/payments';
import axios from 'axios';
import { getApiQuoteResponse } from '../../../selectors/motorPrivateRW/quote';
import { getDocumentsForm } from '../../../selectors/motorPrivateRW/documents';

export const saveDocumentsService = (store, next, action) => {
    (async () => {
        store.dispatch(apiTransitionDocumentsForm.pending());
        try {
            const resp = await saveDocuments(store.getState());
            store.dispatch(submitDocumentsDataSuccess(resp.data));
            store.dispatch(apiTransitionDocumentsForm.success());
        } catch (e) {
            console.error(e);
            store.dispatch(apiTransitionDocumentsForm.failure());
        }
    })();
    return next(action);
};

const saveDocumentsPayload = state => {
    const savedQuoteResponse = getApiQuoteResponse(state);
    const quoteId = savedQuoteResponse?.data?.quotation?.id;
    const documents = getDocumentsForm(state);

    const payload = {
        quoteId,
        nationalId: documents.idUpload.value?.base64File || 'N/A',
        yellowCard: documents.yellowCard.value?.base64File || 'N/A',
        carFrontViewPhoto: documents.frontView.value?.base64File || 'N/A',
        carBackViewPhoto: documents.backView.value?.base64File || 'N/A',
        carLeftSidePhoto: documents.leftView.value?.base64File || 'N/A',
        carRightSidePhoto: documents.rightView.value?.base64File || 'N/A',
        carDashboardPhoto: documents.dashboardView.value?.base64File || 'N/A'
    };

    // Change payload here
    return {
        ...payload
    };
};

const saveDocuments = async state => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/rw-motor-insurance/save/documents';
        return await axios.post(url, saveDocumentsPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa'
            }
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
